

(function($){
  $(function(){
    // resize
    $(window).on('resize', function () {
      // resize check exec
      if (resizeTimer !== false) {
        clearTimeout(resizeTimer);
      }
      resizeTimer = setTimeout(function() {
        checkWindowSize();
      }, 200);
    });
  });


  // on Load event
  $(window).on('load', function(){
    checkWindowSize();
  });


  //スマホメニュー
  var state = false;
  var scrollpos;

  $(function(){
    var swiper_spMenu = new Swiper('#swiper-spMenu', {
      direction: 'vertical',
      slidesPerView: 'auto',
      mousewheelControl: true,
      freeMode: true
    });

    //メニューを開く
    $('#js-menuButton').on('click', function(){
      // $('#sp-nav').stop().slideToggle(500,"swing");
      $(this).toggleClass("-open");
      // $("#inbox").toggleClass("-open");
      $(".sp-nav").toggleClass("-open");
      //モーダル中はスクロールを無効に
      if(state == false) {
        // scrollpos = $(window).scrollTop();
        // $('body').addClass('-fixed').css({'top': -scrollpos});
        state = true;
      } else {
        // $('body').removeClass('-fixed').css({'top': 0});
        // window.scrollTo(0, scrollpos );
        state = false;
      }
      setTimeout(function(){
        if($("#swiper-spMenu").length){
          swiper_spMenu.update();
        }
      },500);
    });
  });


  // resize check exec
  var resizeTimer = false;
  function checkWindowSize(){
    var windowW = $(window).width();
    if(windowW > 960 ){
      $("").each(function() {
        $(this).find("li").tile(3);
      });
    } else {
      $("").find("li").height("auto");
    }

    //スマホメニュー
    if($("#swiper-spMenu").length&&windowW>960&&state!=false){
      $('#sp-nav').hide();
      $('#js-menuButton').removeClass("-open");
      $('body').removeClass('-fixed').css({'top': 0});
      window.scrollTo(0,scrollpos);
      state = false;
    }
  }

})(jQuery);